module.exports = __webpack_public_path__ + "img/12_105.73f09067.png";